import { DashboardRecentSpenderListRestEndpointService } from '@api'
import type { PaginationState } from '@tanstack/react-table'
import { useQuery } from 'react-query'

import { handleError } from '@/utils/error'

export function useGetRecentSpendLists(
  creatorId: number,
  paginationState: PaginationState,
  searchQuery: string,
) {
  const { data, isFetching, error, isSuccess, isError, refetch } = useQuery({
    queryKey: [
      'creator',
      creatorId,
      'recent-spend-list',
      paginationState,
      searchQuery,
    ],
    queryFn: () =>
      DashboardRecentSpenderListRestEndpointService.dashboardGetRecentSpenderLists(
        {
          creatorId,
          page: paginationState.pageIndex,
          size: paginationState.pageSize,
          name: searchQuery,
        },
      ),
    enabled: !!creatorId,
    onError: (error) =>
      handleError(error, 'Failed to get recent spend lists', refetch),
  })

  return { data, isFetching, error, isSuccess, isError }
}
